import { normalizeCallingListRanking } from '../../lib'
import { CreateCallingListParams, UpdateCallingListParams } from '../models'

const CALLING_LIST_RANKINGS_LENGTH_MESSAGE =
  'Ranking count must match the number of partner or location ids.'

// Payload builder for spLutCallingListCreateFromFile. A request carries exactly
// one identifier kind: when locationIds is present the upload was a LocationId
// file, so send p.LocationIds; otherwise default to p.PartnerIds, preserving
// the historical behavior for PartnerId uploads.
export const buildCallingListCreateParams = ({
  campaignId,
  isr,
  partnerIds,
  locationIds,
  ranking,
  rankings,
}: CreateCallingListParams) => {
  const ids = locationIds !== undefined ? locationIds : partnerIds

  if (rankings !== undefined && ids?.length !== rankings.length) {
    throw new Error(CALLING_LIST_RANKINGS_LENGTH_MESSAGE)
  }

  const params = {
    'p.CampaignId': campaignId,
    'p.ISR': isr,
    ...(locationIds !== undefined
      ? { 'p.LocationIds': locationIds }
      : { 'p.PartnerIds': partnerIds }),
  }

  return {
    ...params,
    ...(ranking !== undefined ? { 'p.Ranking': normalizeCallingListRanking(ranking) } : {}),
    ...(rankings !== undefined ? { 'p.Rankings': rankings.map(normalizeCallingListRanking) } : {}),
  }
}

export const buildCallingListUpdateParams = ({
  entryId,
  isVisible,
  ranking,
}: UpdateCallingListParams) => {
  const params = {
    'p.EntryId': entryId,
    ...(isVisible !== undefined ? { 'p.IsVisible': isVisible } : {}),
  }

  return ranking !== undefined
    ? { ...params, 'p.Ranking': normalizeCallingListRanking(ranking) }
    : params
}
